(() => {
  let animationFrame;

  const applyCartEditorSettings = () => {
    const drawer = document.querySelector('[data-cart-drawer].store-cart');
    if (!drawer) return;

    const emptyState = drawer.querySelector('.store-cart__empty');
    const emptyText = emptyState?.querySelector('p');
    const emptyButton = emptyState?.querySelector('a');

    if (
      emptyText &&
      drawer.dataset.cartEmptyText &&
      emptyText.textContent !== drawer.dataset.cartEmptyText
    ) {
      emptyText.textContent = drawer.dataset.cartEmptyText;
    }

    if (emptyButton) {
      if (
        drawer.dataset.cartEmptyButton &&
        emptyButton.textContent !== drawer.dataset.cartEmptyButton
      ) {
        emptyButton.textContent = drawer.dataset.cartEmptyButton;
      }

      if (
        drawer.dataset.cartEmptyUrl &&
        emptyButton.getAttribute('href') !== drawer.dataset.cartEmptyUrl
      ) {
        emptyButton.setAttribute('href', drawer.dataset.cartEmptyUrl);
      }
    }

    drawer.querySelectorAll('.store-cart-upsell__add').forEach((button) => {
      if (
        drawer.dataset.cartUpsellAddLabel &&
        !button.disabled &&
        button.textContent.trim() !== drawer.dataset.cartUpsellAddLabel
      ) {
        button.textContent = drawer.dataset.cartUpsellAddLabel;
      }
    });
  };

  const scheduleCartEditorSettings = () => {
    window.cancelAnimationFrame(animationFrame);
    animationFrame = window.requestAnimationFrame(applyCartEditorSettings);
  };

  const drawer = document.querySelector('[data-cart-drawer].store-cart');
  if (drawer) {
    const observer = new MutationObserver(scheduleCartEditorSettings);
    observer.observe(drawer, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', scheduleCartEditorSettings);
  document.addEventListener('shopify:section:reorder', scheduleCartEditorSettings);
  applyCartEditorSettings();
})();
